import {
	ADD_MESSAGE,
	ADD_MESSAGE_SUCCESS,
	ADD_MESSAGE_FAIL,
	ADD_MESSAGE_RESET,
} from '../actions/addMessageAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const addMessageReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_MESSAGE:
			return {
				...state,
				apiState: 'loading',
			};
		case ADD_MESSAGE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case ADD_MESSAGE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case ADD_MESSAGE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default addMessageReducer;
